const excludes = ['/popup/', '/embed/'];

export default excludes;